import { ErrorMessage } from '@hookform/error-message';
import clsx from 'clsx';
import React from 'react';
export const FormError = (props) => {
    const { className = 'font-bold text-app-red-dark block text-sm ml-2 mt-1', ...rest } = props;
    return (React.createElement(ErrorMessage, { ...rest, render: ({ message }) => (React.createElement("strong", { className: clsx(className) }, message)) }));
};
